/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkNDCAndAddToDetailsTable,
  searchNDCByIDORDrugName,
  setNDCErrorPopupMessage,
  setNDCLoading,
  setSearchByNDCIDTwo,
} from '../../store/action';
import MoveToDetailsIconContainer from '../MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import NDCViewDetailsTable from '../NDCViewDetailsTable/NDCViewDetailsTable';
import SearchComponent from './SearchComponent';

const NDCByID = ({ fullScreen, setFullScreen, isViewNDCHidden }) => {
  const dispatch = useDispatch();
  const searchByNDCIdStore = useSelector(
    (state) => state.sharedState.ndc.searchByNDCId
  );
  const [searchByNDCID, setSearchByNDCID] = useState('');
   const handleSearchClick = async () => {
  if (searchByNDCID) {
    const searchByNDCIDSplit = searchByNDCID.split('-');    
    if (
      (searchByNDCIDSplit.length === 1 && searchByNDCIDSplit[0].length === 11) ||
      (searchByNDCIDSplit.length === 3 &&
        searchByNDCIDSplit[0].length === 5 &&
        searchByNDCIDSplit[1].length === 4 &&
        searchByNDCIDSplit[2].length === 2)
    ) {
      dispatch(setNDCLoading(true));
      const searchResult = await searchNDCByIDORDrugName({
        searchBy: 'ndc',
        inputValue: searchByNDCID,
      });
      dispatch(setNDCLoading(false));
      if (!searchResult) {
        dispatch(setNDCErrorPopupMessage('NDC not found.'));
      } else {
        dispatch(setNDCErrorPopupMessage(null));
        dispatch(checkNDCAndAddToDetailsTable(searchResult));
      }
    } else if (!searchByNDCID.trim()) {
      dispatch(setNDCErrorPopupMessage('Please input an NDC to search.'));
    } else {
      dispatch(
        setNDCErrorPopupMessage(
          'Please enter NDC in the format XXXXX-XXXX-XX or XXXXXXXXXXX.'
        )
      );
    }
  } else {
    dispatch(setNDCErrorPopupMessage('Invalid NDC input.'));
  }

  dispatch(setSearchByNDCIDTwo(searchByNDCID));
};
  

  useEffect(() => {
    setSearchByNDCID(searchByNDCIdStore);
  }, []);

  return (
    <div className="my-4 container mx-0">
      <div className="row">
        {!fullScreen && (
          <>
            <div className="col-5 d-flex  p-0">
              <SearchComponent
                searchByNDCID={searchByNDCID}
                setSearchByNDCID={setSearchByNDCID}
                searchOnEnter={handleSearchClick}
              />
            </div>
            <div className="col-2 px-2">
              <MoveToDetailsIconContainer
                handleSingleMove={() => handleSearchClick()}
                handleRemove={() => {}}
              />
            </div>
          </>
        )}
        <div
          className={`${
            fullScreen ? 'col-12' : 'col-5'
          } d-flex flex-column p-0  mt-4`}
        >
          <NDCViewDetailsTable
            isViewNDCHidden={isViewNDCHidden}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
          />
        </div>
      </div>
    </div>
  );
};

export default NDCByID;
